import { apiFactory } from "../api_factory";

export const csvExportsApi = apiFactory({
  path: `/api/v4/csv-exports/`
});
